import ApiService from "@/api/ApiService";
import { ContentCopy, CopyAll, Delete, Edit } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Fragment } from "react";
import AddExternalDialog, { NewExternalOrder } from "./AddNewExternalDialog";
import ConfirmDialog from "@/shared/dialogs/ConfirmDialog";

export function DirectNewExternalMaterialEditor({ allowedPlant, order }: { allowedPlant: number; order: NewExternalOrder }) {
  const queryClient = useQueryClient();

  const saveMutation = useMutation<NewExternalOrder, AxiosResponse, NewExternalOrder>({
    mutationFn: ApiService.editEntity("externalMaterialOrder", undefined, "external"),
    onSuccess: (answer) => {
      queryClient.invalidateQueries({ queryKey: ["getMaterialCalendar"] });
      queryClient.invalidateQueries({ queryKey: ["getExternalOrderHistory", String(order.id)] });
    },
  });

  const createMutation = useMutation<NewExternalOrder, AxiosResponse, NewExternalOrder>({
    mutationFn: ApiService.createEntity("externalMaterialOrder", true, { v: "external" }),
    onSuccess: (answer) => {
      queryClient.invalidateQueries({ queryKey: ["getMaterialCalendar"] });
      queryClient.invalidateQueries({ queryKey: ["getExternalOrderHistory", String(order.id)] });
    },
  });

  const loading = saveMutation.isPending;

  return true ? (
    <Fragment>
      <AddExternalDialog
        save={function (order: NewExternalOrder): void {
          saveMutation.mutate({ ...order });
        }}
        allowedPlant={allowedPlant}
        OpenButton={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <Edit fontSize="small" />
          </IconButton>
        )}
        initialState={order}
      />
      <AddExternalDialog
        save={function (order: NewExternalOrder): void {
          createMutation.mutate({ ...order });
        }}
        allowedPlant={allowedPlant}
        OpenButton={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <ContentCopy fontSize="small" />
          </IconButton>
        )}
        initialState={{ ...order, id: 0 }}
      />
      <ConfirmDialog
        title="Wirklich löschen?"
        confirmText="Löschen"
        CustomButton={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <Delete fontSize="small" />
          </IconButton>
        )}
        onAccept={() => saveMutation.mutate({ ...order, deleted: true })}
      />
    </Fragment>
  ) : null;
}
